import React from 'react';
import { HeartIcon, UserIcon } from 'lucide-react';
import { Stars } from './Stars';
import { longTestimonials } from '../data/content';
const avatarColors = ['#ff6b57', '#4b8df8', '#ffc83d', '#a07bf7'];
export function LongTestimonials() {
  return <section aria-labelledby="long-testimonials" className="bg-ink px-5 py-20 sm:py-24" data-id="element-141" data-mp="35u2c3vv6tsy2">
      <div className="mx-auto max-w-6xl" data-id="element-142" data-mp="30zy3l869xcuv">
        <h2 id="long-testimonials" className="flex items-center justify-center gap-3 text-center text-3xl font-black uppercase text-white sm:text-4xl" data-id="element-143" data-mp="3fpnis7b7bhe5">
          <HeartIcon className="h-8 w-8 fill-coral text-coral" aria-hidden="true" data-id="element-144" data-mp="3aqsregz64kif" />
          Más familias que ya lo tienen
        </h2>
        <ul className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-145" data-mp="3js0avsx0zgsg">
          {longTestimonials.map((t, i) => <li key={i} className="flex flex-col rounded-3xl border border-line bg-surface p-7" data-id="element-146" data-mp="1uckcn8kn3fhc" data-mpi={i}>
              <div className="flex items-center gap-4" data-id="element-147" data-mp="1pdzerfsv17w2">
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full" style={{
              backgroundColor: avatarColors[i % avatarColors.length]
            }} data-id="element-148" data-mp="1pfk8x4b9iote">
                  <UserIcon className="h-6 w-6 text-ink" aria-hidden="true" data-id="element-149" data-mp="3u2cr356c8dy5" />
                </span>
                <div data-id="element-150" data-mp="2tyvcbp8cvvr">
                  <p className="text-base font-black text-white" data-id="element-151" data-mp="2tffd0j54hkd">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-152" data-mp="7mryiv51vw5q">
                    {t.country}
                    {t.product && <> · {t.product}</>}
                  </p>
                </div>
              </div>
              <div className="mt-5" data-id="element-153" data-mp="gldc0bvo0kzn">
                <Stars className="h-5 w-5" data-id="element-154" data-mp="gohpy0yxmv3i" />
              </div>
              <blockquote className="mt-4 text-lg leading-relaxed text-cream" data-id="element-155" data-mp="lmt1qh8sffod">«{t.quote}»</blockquote>
            </li>)}
        </ul>
      </div>
    </section>;
}